import * as api from '../api';
import axios from 'axios';
// import router from '../routerManuaConfig'
import Vue from 'vue';
let base = api.BaseApiUrl;

//考核管理
export const GetCheck = params => {
    return axios.get(`${base}/api/RatingManage/GetCheck`, { params: params });
};
export const GetChecks = params => {
    return axios.get(`${base}/api/RatingManage/GetChecks`, { params: params });
};
export const DeleteCheckByIds = params => {
    return axios.post(`${base}/api/RatingManage/DeleteCheckByIds`, params);
};
export const AddCheck = params => {
    return axios.post(`${base}/api/RatingManage/AddCheck`, params);
};
export const PutCheck = params => {
    return axios.post(`${base}/api/RatingManage/PutCheck`, params);
};
//考核模块管理
export const Getcheckmodules = params => {
    return axios.get(`${base}/api/RatingManage/GetChcekModules`, { params: params });
};
export const GetCheckModuleStIndex = params => {
    return axios.get(`${base}/api/RatingManage/GetCheckModuleStIndex`, { params: params });
};
export const GetCheckModule = params => {
    return axios.get(`${base}/api/RatingManage/GetCheckModule`, { params: params });//分页获取
};
export const GetCheckModuleById = params => {
    return axios.get(`${base}/api/RatingManage/GetCheckModuleById`, { params: params });
};
export const DeleteCheckModuleByIds = params => {
    return axios.post(`${base}/api/RatingManage/DeleteCheckModuleByIds`, params);
};
export const AddCheckModule = params => {
    return axios.post(`${base}/api/RatingManage/AddCheckModule`, params);
};
export const PutCheckModule = params => {
    return axios.post(`${base}/api/RatingManage/PutCheckModule`, params);
};
//考核项管理
export const GetCheckPointLs = params => {
    return axios.get(`${base}/api/RatingManage/GetCheckPoint`, { params: params });//分页获取
};
export const GetCheckPointParticulars = params => {
    return axios.get(`${base}/api/RatingManage/GetCheckPointParticulars`, { params: params });
};
export const GetCheckPointStIndex = params => {
    return axios.get(`${base}/api/RatingManage/GetCheckPointStIndex`, { params: params });
};
export const DeleteCheckPointByIds = params => {
    return axios.post(`${base}/api/RatingManage/DeleteCheckPointByIds`, params);
};
export const AddCheckPoint = params => {
    return axios.post(`${base}/api/RatingManage/AddCheckPoint`, params);
};
export const PutCheckPoint = params => {
    return axios.post(`${base}/api/RatingManage/PutCheckPoint`, params);
};

// 考核细项管理
export const GetcheckdetailsByid = params => {
    return axios.get(`${base}/api/RatingManage/GetallCheckDetail`, { params: params });//通过moduleid获取考核细项
};
export const AddCheckDetail = params => {
    return axios.post(`${base}/api/RatingManage/AddCheckDetail`, params);
};
export const GetCheckDetailLs = params => {
    return axios.get(`${base}/api/RatingManage/GetCheckDetail`, { params: params });//根据考核项ID或者模块ID，分页获取考核细项
};
export const GetCheckDetailParticulars = params => {
    return axios.get(`${base}/api/RatingManage/GetCheckDetailParticulars`, { params: params });
};
export const GetCheckDetailStIndex = params => {
    return axios.get(`${base}/api/RatingManage/GetCheckDetailStIndex`, { params: params });
};
export const DeleteCheckDetailByIds = params => {
    return axios.post(`${base}/api/RatingManage/DeleteCheckDetailByIds`, params);
};
export const PutCheckDetail = params => {
    return axios.post(`${base}/api/RatingManage/PutCheckDetail`, params);
};

//文件模板管理
export const GetFiletemplatesPage = params => {
    return axios.get(`${base}/api/RatingManage/GetFiletemplates`, { params: params });
};
export const UploadFiletmplate = params => {
    return axios.post(`${base}/api/RatingManage/AddFiletemplate`, params);

};
export const GetFiletemplechecdetail = params => {
    return axios.get(`${base}/api/RatingManage/GetFiletempleChecdetail`, { params: params });
};
export const Downtemplate = params => {
    return axios.get(`${base}/api/RatingManage/DownFiletemplate`, { params: params, responseType: 'blob' });
};


export const RemoveFiletemplate = params => {
    return axios.get(`${base}/api/RatingManage/DeleteFiletempltae`, { params: params });
};

export const GetcheckpointitemBydetalids = params => {
    return axios.post(`${base}/api/RatingManage/GetCheckpoinItemBydetailIds`, params);
};